var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-laravel-test"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.laravel}},[_vm._v("laravel")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.session}},[_vm._v("session")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }